export const WORDS = [
  'نعناع',
  'موهوب',
  'ينبوع',
  'تفاحة',
  'كوادر',
  'طاووس',
  'شاحنة',
  'مقترح',
  'عشرون',
  'عجائب',
  'ذوبان',
  'مبارك',
  'عوجاء',
  'معطاء',
  'ليونة',
  'بضاعة',
  'نصيحة',
  'توجيب',
  'بنتان',
  'ظرفاء',
  'بادية',
  'مرايا',
  'مادية',
  'شفعاء',
  'بائقة',
  'كابوس',
  'مقهقه',
  'تلاوة',
  'مذاعة',
  'مقالة',
  'مسمار',
  'مستاء',
  'تصويب',
  'باكرة',
  'مرساة',
  'مراجع',
  'كارثة',
  'تابوت',
  'شواغر',
  'نواهي',
  'صحراء',
  'نوايا',
  'غلاظة',
  'ريحان',
  'وجيزة',
  'نقاهة',
  'نكراء',
  'تاريخ',
  'مجلات',
  'طاغوت',
  'وسطاء',
  'ولادة',
  'ترضية',
  'توصية',
  'خضراء',
  'باحثة',
  'منطاد',
  'مقولة',
  'مجنحة',
  'مؤدبة',
  'تعيسة',
  'مبتسم',
  'وكلاء',
  'عنقاء',
  'تابعة',
  'متضحة',
  'نشطاء',
  'براقة',
  'ميزان',
  'ترجمة',
  'ثرثار',
  'جيران',
  'باهية',
  'مطبوع',
  'توظيف',
  'فنجان',
  'ماضية',
  'مبسطة',
  'مصفاة',
  'قمامة',
  'حيوان',
  'جاسوس',
  'رمضان',
  'عصفور',
  'مهارة',
  'مشوشة',
  'تنقيب',
  'تضاعف',
  'مترفة',
  'عزباء',
  'عذراء',
  'تجارة',
  'زعماء',
  'محلات',
  'ترقية',
  'تمايل',
  'ميلاد',
  'بلدان',
  'توضيح',
  'ريعان',
  'وسيمة',
  'مذاهب',
  'فضيحة',
  'مصونة',
  'مائية',
  'مرجان',
  'مباحة',
  'متحور',
  'باعثة',
  'زملاء',
  'جدارة',
  'مثمرة',
  'مقدمة',
  'كرماء',
  'تسلية',
  'مشاكس',
  'عميقة',
  'مهينة',
  'توديع',
  'تشرذم',
  'توفير',
  'موسوس',
  'شواطئ',
  'تاجرة',
  'وهمية',
  'باخرة',
  'قانون',
  'ملونة',
  'محدود',
  'لطفاء',
  'وصاية',
  'متعال',
  'مؤذية',
  'نظيفة',
  'شرفاء',
  'حمراء',
  'ناموس',
  'مأمون',
  'مسافر',
  'بدانة',
  'توصيل',
  'لفافة',
  'جاموس',
  'مباني',
  'فواكه',
  'صابون',
  'غلمان',
  'مجرات',
  'ثقافة',
  'تائبة',
  'تأسيس',
  'توفيق',
  'ميناء',
  'مجيدة',
  'وزراء',
  'مباحث',
  'وكيلة',
  'تضارب',
  'متيمة',
  'تسوية',
  'تائهة',
  'علماء',
  'ميقات',
  'معيشة',
  'بائعة',
  'ديوان',
  'صاروخ',
  'تعبئة',
  'فانوس',
  'تفاهة',
  'مأكول',
  'مضياف',
  'مشوهة',
  'ماشية',
  'باهتة',
  'مؤيدة',
  'وكالة',
  'بطلان',
  'كنيسة',
  'مجدية',
  'قرنفل',
  'خواطر',
  'مجتاز',
  'توفية',
  'غرامة',
  'معتدل',
  'عواطف',
  'زخارف',
  'ملامح',
  'عامود',
  'مناعة',
  'عصفور',
  'ملعقة',
  'زرافة',
  'معقول',
  'زراعة',
  'تمثيل',
  'سداسي',
  'مهاجر',
  'جراحة',
  'معاكس',
  'شبيبة',
  'معابد',
  'مجاهد',
  'تجريب',
  'مواقد',
  'شريفة',
  'عنصري',
  'مساجد',
  'سلامة',
  'بطيخة',
  'سجادة',
  'رزينة',
  'شحاذة',
  'حفلات',
  'لطافة',
  'تعنيف',
  'متاحف',
  'راغبة',
  'معزوم',
  'تسلسل',
  'سلاحف',
  'مدارس',
  'مستور',
  'رباعي',
  'تعريف',
  'مواقف',
  'هيفاء',
  'ثخينة',
  'تحميل',
  'مكاتب',
  'علامة',
  'مواضع',
  'ثنائي',
  'لطيفة',
  'تسبيح',
  'مجالس',
  'توريد',
  'معاهد',
  'مصاحب',
  'رفيعة',
  'تحفيز',
  'مكتبة',
  'بوصلة',
  'كلمات',
  'دائرة',
  'مسموح',
  'شعراء',
  'زرعات',
  'مساعد',
  'سذاجة',
  'سميحة',
  'همسات',
  'جرافة',
  'دراقة',
  'مختبر',
  'مكياج',
  'مسلسل',
  'تصريح',
  'سحابة',
  'فارقة',
  'خماسي',
  'مجموع',
  'مثبتة',
  'ممتعة',
  'مماثل',
  'عائدة',
  'صناعة',
  'مجربة',
  'معبدة',
  'ممنوع',
  'مصاحف',
  'مكافح',
  'تقنية',
  'مجروح',
  'مصطحب',
  'صحيحة',
  'فارسة',
  'شوائب',
  'ثلاثي',
  'مواكب',
  'زهراء',
  'سهولة',
  'متاجر',
  'مقاتل',
  'صفراء',
  'خاطئة',
  'مقروء',
  'دائرة',
  'توحيد',
  'كهيلة',
  'الستة',
  'صعوبة',
  'مربعة',
  'مجوهر',
  'مقاعد',
  'مطروح',
  'مكتوب',
  'هادفة',
  'مدافع',
  'شبابي',
  'ترهيب',
  'تجريح',
  'كهولة',
  'سجينة',
  'معدات',
  'لوحات',
  'هجرات',
  'عفراء',
  'مشاعر',
  'مرادف',
  'خنساء',
  'مدروس',
  'كواشف',
  'عباءة',
  'محتوى',
  'حلقات',
  'كريمة',
  'تسنيم',
  'مهنية',
  'شاحبة',
  'عصيبة',
  'مقتول',
  'موصول',
  'معينة',
  'محبوب',
  'باسطة',
  'سابقة',
  'مخطوف',
  'جاهلة',
  'مقطور',
  'غفلان',
  'مجبور',
  'نشطاء',
  'مبثوق',
  'ظالمة',
  'محاول',
  'تورية',
  'ماعون',
  'مجاوز',
  'مخشية',
  'أجزاء',
  'مشيئة',
  'ثكلان',
  'موهوم',
  'ناضجة',
  'أعيان',
  'مغروم',
  'فاتحة',
  'منقوص',
  'فائحة',
  'مبروم',
  'حاكمة',
  'ميزان',
  'محسوب',
  'خاطرة',
  'محمول',
  'بارزة',
  'موشوم',
  'منطوق',
  'ساجدة',
  'مرصوص',
  'تيجان',
  'محمود',
  'إطراء',
  'مدموج',
  'ظافرة',
  'ملكوم',
  'عرفان',
  'مقصود',
  'طغيان',
  'مجزية',
  'إبداء',
  'مهنية',
  'واعدة',
  'تأميم',
  'لاقطة',
  'معدوم',
  'صابرة',
  'مكلوم',
  'طاعنة',
  'مرزوق',
  'حاضنة',
  'متفوق',
  'ظاهرة',
  'تأويل',
  'شامخة',
  'ممحوة',
  'تلقاء',
  'مبعوث',
  'فاحصة',
  'مأبون',
  'راسخة',
  'مجدوب',
  'طارحة',
  'ملموس',
  'نابعة',
  'مرسوم',
  'إبقاء',
  'مأثوم',
  'عمران',
  'حاسمة',
  'مراود',
  'محروق',
  'إذعان',
  'متحول',
  'مثقوب',
  'واثقة',
  'محروم',
  'فائزة',
  'متبوع',
  'تنمية',
  'مخطوط',
  'ناقضة',
  'مخصوص',
  'رجحان',
  'متذوق',
  'وجدان',
  'مأثور',
  'مجروح',
  'مليئة',
  'محفوف',
  'شاكرة',
  'خاتمة',
  'معمور',
  'صادقة',
  'مبتور',
  'صانعة',
  'محروس',
  'مصيدة',
  'شكران',
  'مضيعة',
  'مقصور',
  'سامعة',
  'توشية',
  'ديوان',
  'مختوم',
  'زاهدة',
  'متكون',
  'مريغة',
  'معمول',
  'إرضاء',
  'متجول',
  'مريعة',
  'طلقاء',
  'متكور',
  'شافية',
  'محصور',
  'باهتة',
  'مخروط',
  'مدينة',
  'محظور',
  'ذؤبان',
  'مجرور',
  'سانحة',
  'مبهور',
  'أشجان',
  'مبرود',
  'واطئة',
  'محجوز',
  'سلطان',
  'مديدة',
  'مأذون',
  'صامتة',
  'مخدوش',
  'حاملة',
  'كتمان',
  'ساعية',
  'مبثوث',
  'حاصلة',
  'مجموع',
  'قربان',
  'مسموم',
  'أبناء',
  'مهزوز',
  'سارية',
  'منصوص',
  'شاهقة',
  'محسوم',
  'ناطقة',
  'تأييد',
  'محاور',
  'تعميم',
  'أحباء',
  'مكيدة',
  'مأمون',
  'رادعة',
  'متلوف',
  'ناضرة',
  'مخبول',
  'ناضحة',
  'مبروك',
  'تسوية',
  'مقصوص',
  'عاجزة',
  'محسوس',
  'جدران',
  'متخوف',
  'مقبوض',
  'واعظة',
  'محبور',
  'فاسدة',
  'محكوم',
  'لاصقة',
  'مبخوت',
  'صادمة',
  'محصود',
  'مخروق',
  'عادلة',
  'محبوس',
  'مأخوذ',
  'مقطوع',
  'مقذوف',
  'رهبان',
  'غامرة',
  'ثعبان',
  'متشوق',
  'ناجعة',
  'متقوس',
  'خاضعة',
  'محشور',
  'طاهية',
  'محسود',
  'فرقان',
  'ملغوم',
  'سرعان',
  'مقطوف',
  'نبلاء',
  'مانعة',
  'محشود',
  'إتقان',
  'محصول',
  'مثلوم',
  'خافضة',
  'ملصوق',
  'ريعان',
  'مصقول',
  'غثيان',
  'محروز',
  'خجلان',
  'محدود',
  'سيلان',
  'متزوج',
  'إعلاء',
  'منقوض',
  'مريرة',
  'مجلوب',
  'حاشدة',
  'مأجور',
  'صاحبة',
  'متعوس',
  'ريحان',
  'مبغوض',
  'راجفة',
  'منقوط',
  'بارعة',
  'مجحود',
  'خارقة',
  'متلون',
  'صاعدة',
  'مزينة',
  'حازمة',
  'محظوظ',
  'صارخة',
  'مغمود',
  'هذيان',
  'متروك',
  'صبيان',
  'محموم',
  'باسمة',
  'محلول',
  'ساخطة',
  'محذوف',
  'غارقة',
  'تأمين',
  'داحضة',
  'معيبة',
  'بنيان',
  'مجعول',
  'ثاقبة',
  'مديون',
  'حائزة',
  'مبذول',
  'راجية',
  'محبوك',
  'نافثة',
  'مأجوج',
  'طاحنة',
  'مجزوم',
  'بسطاء',
  'محجور',
  'حامدة',
  'مجاور',
  'هابطة',
  'مثلوج',
  'سبحان',
  'عارمة',
  'نسيان',
  'مثبوت',
  'سريان',
  'مأهول',
  'نيران',
  'مخطوب',
  'ناصعة',
  'محفور',
  'أخطاء',
  'مهيبة',
  'عدوان',
  'طامحة',
  'إعفاء',
  'مقروض',
  'عازفة',
  'غفران',
  'حافظة',
  'إقصاء',
  'بادرة',
  'محقون',
  'خادعة',
  'مهموم',
  'حاشرة',
  'عصيان',
  'سابحة',
  'مأمور',
  'إعطاء',
  'فارسة',
  'خافقة',
  'ثلاثة',
  'أربعة',
  'تذكرة',
  'شجيرة',
  'ضيافة',
  'تدفئة',
  'أسبوع',
  'أرواح',
  'ضوضاء',
  'أعضاء',
  'اثنان',
  'أسماء',
  'زمكان',
  'تدبير',
  'معجون',
  'تجميل',
  'رادار',
  'تقارب',
  'معمار',
  'تبريد',
  'نعناع',
  'موهوب',
  'ينبوع',
  'تفاحة',
  'كوادر',
  'طاووس',
  'شاحنة',
  'مقترح',
  'عشرون',
  'عجائب',
  'ذوبان',
  'مبارك',
  'عوجاء',
  'معطاء',
  'ليونة',
  'بضاعة',
  'نصيحة',
  'توجيب',
  'بنتان',
  'ظرفاء',
  'بادية',
  'مرايا',
  'مادية',
  'شفعاء',
  'بائقة',
  'كابوس',
  'مقهقه',
  'تلاوة',
  'مذاعة',
  'مقالة',
  'مسمار',
  'مستاء',
  'تصويب',
  'باكرة',
  'مرساة',
  'مراجع',
  'كارثة',
  'تابوت',
  'شواغر',
  'نواهي',
  'صحراء',
  'نوايا',
  'غلاظة',
  'ريحان',
  'وجيزة',
  'نقاهة',
  'نكراء',
  'تاريخ',
  'مجلات',
  'طاغوت',
  'وسطاء',
  'ولادة',
  'ترضية',
  'توصية',
  'خضراء',
  'باحثة',
  'منطاد',
  'مقولة',
  'مجنحة',
  'مؤدبة',
  'تعيسة',
  'مبتسم',
  'وكلاء',
  'عنقاء',
  'تابعة',
  'متضحة',
  'نشطاء',
  'براقة',
  'ميزان',
  'ترجمة',
  'ثرثار',
  'جيران',
  'باهية',
  'مطبوع',
  'توظيف',
  'فنجان',
  'ماضية',
  'مبسطة',
  'مصفاة',
  'قمامة',
  'حيوان',
  'جاسوس',
  'رمضان',
  'عصفور',
  'مهارة',
  'مشوشة',
  'تنقيب',
  'تضاعف',
  'مترفة',
  'عزباء',
  'عذراء',
  'تجارة',
  'زعماء',
  'محلات',
  'ترقية',
  'تمايل',
  'ميلاد',
  'بلدان',
  'توضيح',
  'ريعان',
  'وسيمة',
  'مذاهب',
  'فضيحة',
  'مصونة',
  'مائية',
  'مرجان',
  'مباحة',
  'متحور',
  'باعثة',
  'زملاء',
  'جدارة',
  'مثمرة',
  'مقدمة',
  'كرماء',
  'تسلية',
  'مشاكس',
  'عميقة',
  'مهينة',
  'توديع',
  'تشرذم',
  'توفير',
  'موسوس',
  'شواطئ',
  'تاجرة',
  'وهمية',
  'باخرة',
  'قانون',
  'ملونة',
  'محدود',
  'لطفاء',
  'وصاية',
  'متعال',
  'مؤذية',
  'نظيفة',
  'شرفاء',
  'حمراء',
  'ناموس',
  'مأمون',
  'مسافر',
  'بدانة',
  'توصيل',
  'لفافة',
  'جاموس',
  'مباني',
  'فواكه',
  'صابون',
  'غلمان',
  'مجرات',
  'ثقافة',
  'تائبة',
  'تأسيس',
  'توفيق',
  'ميناء',
  'مجيدة',
  'وزراء',
  'مباحث',
  'وكيلة',
  'تضارب',
  'متيمة',
  'تسوية',
  'تائهة',
  'علماء',
  'ميقات',
  'معيشة',
  'بائعة',
  'ديوان',
  'صاروخ',
  'تعبئة',
  'فانوس',
  'تفاهة',
  'مأكول',
  'مضياف',
  'مشوهة',
  'ماشية',
  'باهتة',
  'مؤيدة',
  'وكالة',
  'بطلان',
  'كنيسة',
  'مجدية',
  'قرنفل',
  'خواطر',
  'مجتاز',
  'توفية',
  'غرامة',
  'معتدل',
  'عواطف',
  'زخارف',
  'ملامح',
  'عامود',
  'مناعة',
  'عصفور',
  'ملعقة',
  'زرافة',
  'معقول',
  'زراعة',
  'تمثيل',
  'سداسي',
  'مهاجر',
  'جراحة',
  'معاكس',
  'شبيبة',
  'معابد',
  'مجاهد',
  'تجريب',
  'مواقد',
  'شريفة',
  'عنصري',
  'مساجد',
  'سلامة',
  'بطيخة',
  'سجادة',
  'رزينة',
  'شحاذة',
  'حفلات',
  'لطافة',
  'تعنيف',
  'متاحف',
  'راغبة',
  'معزوم',
  'تسلسل',
  'سلاحف',
  'مدارس',
  'مستور',
  'رباعي',
  'تعريف',
  'مواقف',
  'هيفاء',
  'ثخينة',
  'تحميل',
  'مكاتب',
  'علامة',
  'مواضع',
  'ثنائي',
  'لطيفة',
  'تسبيح',
  'مجالس',
  'توريد',
  'معاهد',
  'مصاحب',
  'رفيعة',
  'تحفيز',
  'مكتبة',
  'بوصلة',
  'كلمات',
  'دائرة',
  'مسموح',
  'شعراء',
  'زرعات',
  'مساعد',
  'سذاجة',
  'سميحة',
  'همسات',
  'جرافة',
  'دراقة',
  'مختبر',
  'مكياج',
  'مسلسل',
  'تصريح',
  'سحابة',
  'فارقة',
  'خماسي',
  'مجموع',
  'مثبتة',
  'ممتعة',
  'مماثل',
  'عائدة',
  'صناعة',
  'مجربة',
  'معبدة',
  'ممنوع',
  'مصاحف',
  'مكافح',
  'تقنية',
  'مجروح',
  'مصطحب',
  'صحيحة',
  'فارسة',
  'شوائب',
  'ثلاثي',
  'مواكب',
  'زهراء',
  'سهولة',
  'متاجر',
  'مقاتل',
  'صفراء',
  'خاطئة',
  'مقروء',
  'دائرة',
  'توحيد',
  'كهيلة',
  'الستة',
  'صعوبة',
  'مربعة',
  'مجوهر',
  'مقاعد',
  'مطروح',
  'مكتوب',
  'هادفة',
  'مدافع',
  'شبابي',
  'ترهيب',
  'تجريح',
  'كهولة',
  'سجينة',
  'معدات',
  'لوحات',
  'هجرات',
  'عفراء',
  'مشاعر',
  'مرادف',
  'خنساء',
  'مدروس',
  'كواشف',
  'عباءة',
  'محتوى',
  'حلقات',
  'كريمة',
  'تسنيم',
  'مهنية',
  'شاحبة',
  'عصيبة',
  'مقتول',
  'موصول',
  'معينة',
  'محبوب',
  'باسطة',
  'سابقة',
  'مخطوف',
  'جاهلة',
  'مقطور',
  'غفلان',
  'مجبور',
  'نشطاء',
  'مبثوق',
  'ظالمة',
  'محاول',
  'تورية',
  'ماعون',
  'مجاوز',
  'مخشية',
  'أجزاء',
  'مشيئة',
  'ثكلان',
  'موهوم',
  'ناضجة',
  'أعيان',
  'مغروم',
  'فاتحة',
  'منقوص',
  'فائحة',
  'مبروم',
  'حاكمة',
  'ميزان',
  'محسوب',
  'خاطرة',
  'محمول',
  'بارزة',
  'موشوم',
  'منطوق',
  'ساجدة',
  'مرصوص',
  'تيجان',
  'محمود',
  'إطراء',
  'مدموج',
  'ظافرة',
  'ملكوم',
  'عرفان',
  'مقصود',
  'طغيان',
  'مجزية',
  'إبداء',
  'مهنية',
  'واعدة',
  'تأميم',
  'لاقطة',
  'معدوم',
  'صابرة',
  'مكلوم',
  'طاعنة',
  'مرزوق',
  'حاضنة',
  'متفوق',
  'ظاهرة',
  'تأويل',
  'شامخة',
  'ممحوة',
  'تلقاء',
  'مبعوث',
  'فاحصة',
  'مأبون',
  'راسخة',
  'مجدوب',
  'طارحة',
  'ملموس',
  'نابعة',
  'مرسوم',
  'إبقاء',
  'مأثوم',
  'عمران',
  'حاسمة',
  'مراود',
  'محروق',
  'إذعان',
  'متحول',
  'مثقوب',
  'واثقة',
  'محروم',
  'فائزة',
  'متبوع',
  'تنمية',
  'مخطوط',
  'ناقضة',
  'مخصوص',
  'رجحان',
  'متذوق',
  'وجدان',
  'مأثور',
  'مجروح',
  'مليئة',
  'محفوف',
  'شاكرة',
  'خاتمة',
  "تكييس",
  "محاذر",
  "التفع",
  "تسريب",
  "مداوم",
  "تفريع",
  "مفتوق",
  "مرتجع",
  "تمكين",
  "التحف",
  "تناسق",
  "مضبوط",
  "تناذر",
  "ابتلج",
  "مملوح",
  "غطريس",
  "مكتنز",
  "التبس",
  "تلويم",
  "انحجب",
  "تقليم",
  "وساوس",
  "متقرح",
  "تعميد",
  "أبواق",
  "تفصيح",
  "مقنطر",
  "توشيح",
  "مخالف",
  "تبعثر",
  "مهاجم",
  "فوضوي",
  "مكهرب",
  "اندفع",
  "تكميم",
  "أعماق",
  "اغتمس",
  "مشتمل",
  "تعارف",
  "تهاتر",
  "معلوف",
  "تأقلم",
  "تباعد",
  "إقبال",
  "معروق",
  "انفسد",
  "أحوال",
  "تقنين",
  "ماجدة",
  "نواحي",
  "متهرئ",
  "عطشان",
  "تنفيس",
  "إمهال",
  "توزيع",
  "مخاطب",
  "تفاقم",
  "ابتعث",
  "مهلهل",
  "وقائع",
  "تنصير",
  "أطباق",
  "تصوير",
  "انطمس",
  "تقريظ",
  "إنسان",
  "تقطير",
  "وسائد",
  "تعزيم",
  "انفطر",
  "مبايع",
  "تهامل",
  "إمرار",
  "انصقل",
  "مشفوع",
  "انتسق",
  "معدول",
  "أبحاث",
  "منفجر",
  "تكحيل",
  "مداهم",
  "تجلبب",
  "مهراق",
  "تلفلف",
  "مبارز",
  "امتحق",
  "إرباك",
  "مسدود",
  "إعنات",
  "توطيد",
  "انخنق",
  "تصحيف",
  "انغمر",
  "انجلف",
  "تهريب",
  "إصلاح",
  "تنشيف",
  "معطوب",
  "تكريس",
  "مندوف",
  "تبلبل",
  "انزرع",
  "تقديس",
  "مرصوف",
  "صنديد",
  "محافظ",
  "انعكس",
  "تقريب",
  "مجنون",
  "تكعيب",
  "انمحق",
  "منتجع",
  "إقفار",
  "تمتين",
  "انعرج",
  "تناظم",
  "منعقد",
  "نهاية",
  "منقوع",
  "تطمين",
  "أوقاف",
  "تكديس",
  "ملحاح",
  "تقذيف",
  "مساوم",
  "تضعضع",
  "مصادف",
  "تشويق",
  "انجلب",
  "متوسط",
  "إنشاد",
  "نحفاء",
  "متمثل",
  "تظافر",
  "تنويم",
  "إغلاق",
  "منشور",
  "خلفاء",
  "منتشب",
  "خلايا",
  "تهندم",
  "إكبار",
  "مهفهف",
  "إخوان",
  "تصيير",
  "إلغام",
  "تنقيص",
  "مراوغ",
  "تهليل",
  "انمحص",
  "تنميل",
  "إبصار",
  "تعويض",
  "مفاجئ",
  "تلويث",
  "إطعام",
  "أمواج",
  "تشكيك",
  "أولاد",
  "ممغنط",
  "إضلال",
  "تصميم",
  "انسحق",
  "مرتجل",
  "تناثر",
  "امتعض",
  "فتيان",
  "تطبيب",
  "أيتام",
  "انفتل",
  "جزيرة",
  "تتلمذ",
  "مكتشف",
  "تزعزع",
  "مقارن",
  "تأليه",
  "متضاد",
  "تصحير",
  "تعاظم",
  "تصفيق",
  "أعشاب",
  "موقوف",
  "اتحاد",
  "تلفاز",
  "معيشي",
  "انفرط",
  "توكيل",
  "إمعان",
  "تشييط",
  "مصافح",
  "إقحام",
  "معانق",
  "تنعيم",
  "متنوع",
  "إتزان",
  "انصبغ",
  "مكفول",
  "انضغط",
  "تكييف",
  "منطلق",
  "تكهرب",
  "مخاصم",
  "تقطيع",
  "مهاود",
  "تنسيق",
  "إضرام",
  "اختبل",
  "مفتون",
  "منتزع",
  "إكساب",
  "مناضل",
  "انصرع",
  "مكذوب",
  "انفلق",
  "تعتيم",
  "ألغاز",
  "مخالط",
  "إيناع",
  "انتثر",
  "إعوال",
  "انحسم",
  "تشقلب",
  "إعواز",
  "تجاور",
  "تناغم",
  "مذاعن",
  "إنتاج",
  "معقود",
  "انحذف",
  "إهمال",
  "تظريف",
  "ألوان",
  "مبارح",
  "توطين",
  "مشارك",
  "اعتدل",
  "مقنوص",
  "إلحاف",
  "معنوي",
  "اندرج",
  "تفريق",
  "موجود",
  "تبحثر",
  "انخصم",
  "تطهير",
  "إلحاق",
  "منظور",
  "تكاسل",
  "انشطر",
  "تصديق",
  "انفرج",
  "تواصل",
  "انفتق",
  "تكاثر",
  "مفلول",
  "تنكيت",
  "افتخر",
  "مهادن",
  "تبرقع",
  "أوصاف",
  "تعضيد",
  "مفهرس",
  "إيحاش",
  "متقطع",
  "رائدة",
  "تلوين",
  "جعجاع",
  "مطروق",
  "استتب",
  "انعصر",
  "متقيح",
  "انفلع",
  "مراسل",
  "تنزيه",
  "إضمار",
  "تعزيز",
  "انثلم",
  "تقشير",
  "ململم",
  "تصاغر",
  "ملضوم",
  "تظارف",
  "مضغوط",
  "إكثار",
  "تمشيط",
  "إكباب",
  "ميسور",
  "اعتزم",
  "اندلق",
  "مصروع",
  "إيقاف",
  "تبهدل",
  "انصعق",
  "تأصيل",
  "إلزام",
  "عقوبي",
  "إطلاع",
  "أخبار",
  "معتقد",
  "نبيلة",
  "اعترم",
  "تلاعب",
  "مشروط",
  "ابتاع",
  "التأم",
  "مشاكل",
  "توتير",
  "مفلفل",
  "تهجير",
  "ملعوب",
  "تطفيف",
  "مغموس",
  "تكلكل",
  "مواجه",
  "تبلشف",
  "انزجر",
  "مفكوك",
  "انخلع",
  "مهترئ",
  "تلازم",
  "اصطبغ",
  "مفروش",
  "انخذل",
  "معصفر",
  "انكرب",
  "تمويل",
  "فرحان",
  "مصارح",
  "تبتيك",
  "عمالق",
  "تطريب",
  "أوجاع",
  "منطيق",
  "تصالب",
  "مندمج",
  "فخاري",
  "مخارج",
  "تنويه",
  "إطفاح",
  "مهموس",
  "انقشر",
  "مفلطح",
  "انتكس",
  "مشمول",
  "إتضاح",
  "مناهض",
  "توصيف",
  "جزائر",
  "تنشيط",
  "مواصف",
  "تساهل",
  "متفرق",
  "انجرح",
  "تضييق",
  "مسحوب",
  "تهديف",
  "أصحاب",
  "توقيع",
  "انحصر",
  "مقتضب",
  "إكراه",
  "سرادق",
  "تمصير",
  "تعاكس",
  "طفولي",
  "احترس",
  "مشايع",
  "ترنيم",
  "إلباس",
  "تكريم",
  "تراحم",
  "أمراض",
  "تطويق",
  "منمنم",
  "إيصال",
  "مركوب",
  "اقتنع",
  "مضموم",
  "تصنيف",
  "انسفك",
  "تمليق",
  "متورد",
  "أحيان",
  "إفراغ",
  "تصحيح",
  "وثائق",
  "امتزج",
  "توافر",
  "مناقض",
  "تفريح",
  "أجداد",
  "إنكار",
  "معايد",
  "انفرق",
  "تلفان",
  "مساير",
  "تجلمد",
  "أوضاع",
  "تطمير",
  "إلصاق",
  "مكتسب",
  "اضافي",
  "مصطول",
  "تناحر",
  "انتصف",
  "ضروري",
  "أحكام",
  "تفريز",
  "تواجد",
  "تلميع",
  "تقاصر",
  "انحمق",
  "تطريز",
  "انكبس",
  "متعذر",
  "إنثال",
  "حميدة",
  "انعزل",
  "تمويج",
  "انكدر",
  "توثيق",
  "مبرمج",
  "توقيت",
  "متوكل",
  "منقطع",
  "تعميق",
  "معاتب",
  "جمهور",
  "تلامس",
  "متورم",
  "انبعج",
  "مصدور",
  "تهزهز",
  "مسموع",
  "تفيهق",
  "منسوخ",
  "أعصاب",
  "تعجيل",
  "مسبوه",
  "إمتاع",
  "انتسب",
  "معاود",
  "انفسخ",
  "متلمع",
  "فيضان",
  "أكواخ",
  "مصادق",
  "اجتاز",
  "اندهش",
  "ملجوم",
  "أنحاء",
  "موروب",
  "إقعاد",
  "منصرم",
  "أقواس",
  "تبلور",
  "إقفال",
  "انتقض",
  "مسبوق",
  "اعتزل",
  "مثابر",
  "تقسيط",
  "انبرم",
  "مشاغب",
  "أسحار",
  "مداعب",
  "تبارز",
  "ولائم",
  "اغترب",
  "بلوري",
  "انعقف",
  "تمايز",
  "تقلقل",
  "انفرد",
  "تعطيب",
  "مخزون",
  "تصفيد",
  "انطبع",
  "تغليف",
  "مقرمش",
  "انتبه",
  "تمدين",
  "تنفير",
  "إنجاز",
  "تسربل",
  "أزواج",
  "تنبيت",
  "وسائط",
  "منيرة",
  "منقوش",
  "أبطال",
  "مسكون",
  "اشتهر",
  "تربيع",
  "انسطل",
  "مباغت",
  "تناجي",
  "انسبك",
  "عفوية",
  "أحجام",
  "تنوير",
  "إعجاب",
  "مكشوف",
  "أزناد",
  "تفحيم",
  "إضرار",
  "تمغنط",
  "عسكري",
  "انقصف",
  "مذبذب",
  "إفراط",
  "ممدود",
  "انفقس",
  "ميعاد",
  "انشغف",
  "تهذيب",
  "إفصاح",
  "متقبض",
  "تطبيل",
  "انسرق",
  "مكتمل",
  "إغضاب",
  "تنفيذ",
  "أرباح",
  "التزم",
  "انضبط",
  "موصوف",
  "انبتر",
  "مرغوب",
  "ائتلف",
  "مدبدب",
  "تطويع",
  "انجذر",
  "تلزيم",
  "انهصر",
  "تمليح",
  "ازدجر",
  "منقول",
  "تسبسب",
  "مشاطر",
  "تفقيس",
  "أشكال",
  "مهروس",
  "تزايل",
  "تفكيك",
  "معهود",
  "تفقيط",
  "انكسر",
  "موقوت",
  "إيعاز",
  "مستقر",
  "طبيعي",
  "متهدم",
  "انقشع",
  "تضخيم",
  "انفصل",
  "زمردي",
  "تشابك",
  "مفصول",
  "تراكب",
  "غليان",
  "نباتي",
  "أزمان",
  "تفليس",
  "مشاور",
  "تصنيع",
  "مؤامر",
  "تجنيب",
  "أعمال",
  "منحوس",
  "إشعاع",
  "تطقيم",
  "انفعل",
  "تضريس",
  "انفطم",
  "إتساق",
  "تصبير",
  "مقدام",
  "تلويح",
  "انقسم",
  "تعتيد",
  "مشقوق",
  "تصاعب",
  "ملحمي",
  "رقراق",
  "مستمد",
  "ألقاب",
  "متموج",
  "أحداث",
  "تعرقل",
  "تقتيل",
  "تغاير",
  "مكبوس",
  "تبادل",
  "تغريب",
  "تنابذ",
  "موعود",
  "تصبيح",
  "انقرض",
  "توصيم",
  "خارجة",
  "ممتلك",
  "نبهاء",
  "تعلقم",
  "مناوب",
  "تحريك",
  "إقدام",
  "تغيير",
  "مباعد",
  "تكليف",
  "تبرجز",
  "مكلكل",
  "تتابع",
  "منجوم",
  "اعتكف",
  "تمهيد",
  "متفجر",
  "أواسط",
  "متهدج",
  "ابتسم",
  "انتكث",
  "مجابه",
  "تكميد",
  "شجعان",
  "تمريض",
  "انقصد",
  "متضرر",
  "عائلي",
  "مرهون",
  "مزايد",
  "توسوس",
  "مزاحم",
  "تشارك",
  "اكتنز",
  "أدوار",
  "اضطرم",
  "إنفاق",
  "تعطير",
  "منغوم",
  "إيكال",
  "معنعن",
  "بداهة",
  "تصريف",
  "انهضم",
  "تصغير",
  "مضاعف",
  "تخريب",
  "انقصم",
  "تعليب",
  "انغرس",
  "غرامي",
  "تفاؤل",
  "قيصري",
  "منعوت",
  "شارقة",
  "مفتعل",
  "ازدوج",
  "تطبيق",
  "إصرار",
  "تقويض",
  "انسعر",
  "ارتأس",
  "أعقاب",
  "تعادل",
  "تمويه",
  "تعاصر",
  "منصوب",
  "تشاكس",
  "مصقوع",
  "تباحث",
  "مصفوف",
  "تهزيز",
  "مصادم",
  "تضعيف",
  "اندمر",
  "تمجيد",
  "انبهر",
  "متوقد",
  "اقتصر",
  "انعجم",
  "موازن",
  "تكسير",
  "مناشد",
  "تهويل",
  "مزايا",
  "منتصب",
  "إعجاز",
  "محايد",
  "إجبار",
  "ممسوح",
  "إيداع",
  "متنور",
  "ازدهف",
  "متغيم",
  "انكفس",
  "مقابل",
  "تفخيم",
  "انصهر",
  "تعليم",
  "ثنايا",
  "مزاوج",
  "تفنيد",
  "ارتكز",
  "ارتعب",
  "موثوق",
  "تصييف",
  "أمجاد",
  "تطويل",
  "ازدحم",
  "قساوس",
  "تطفيش",
  "ممنوح",
  "اعتطف",
  "مملوك",
  "إقناع",
  "تصويت",
  "سهران",
  "معقوف",
  "احتصد",
  "ضريبي",
  "وسائل",
  "منعرج",
  "فضائي",
  "ملتطم",
  "إغراق",
  "إنهاك",
  "إضعاف",
  "متيسر",
  "انخطف",
  "توتيد",
  "رقارق",
  "تفتيت",
  "مطاوع",
  "تفضيل",
  "إكرام",
  "تجانس",
  "موروث",
  "أستاذ",
  "معيوه",
  "تناسب",
  "مطارد",
  "تواضع",
  "معقوص",
  "تفكير",
  "انقطع",
  "متلفز",
  "وصايا",
  "ملجلج",
  "تعاسر",
  "تضمين",
  "موارد",
  "تصقيع",
  "مدحاض",
  "انبعث",
  "مرقوم",
  "اندرس",
  "تقليل",
  "إطناب",
  "تفاضل",
  "منعكس",
  "وظائف",
  "تمنطق",
  "أرباع",
  "تغضين",
  "مجادل",
  "تعيين",
  "أشراف",
  "مسبول",
  "ارتدع",
  "تجاسر",
  "تفرنج",
  "مقتتل",
  "إيجاز",
  "معسول",
  "تقبيح",
  "ملفوف",
  "انتسج",
  "إتصال",
  "مسيرة",
  "تعويم",
  "انخرق",
  "تغفيل",
  "مداور",
  "تكبيس",
  "أمثال",
  "تعقيد",
  "ملتقط",
  "ألعاب",
  "مسجون",
  "تصليب",
  "إعزاز",
  "منتحل",
  "إصغار",
  "منسكب",
  "تفضيح",
  "معادل",
  "تنحيف",
  "مغالب",
  "تعكير",
  "إتيان",
  "اندبغ",
  "تلقيح",
  "إعذار",
  "انسطح",
  "تمييز",
  "إطلال",
  "مسقوف",
  "احترز",
  "إتساع",
  "مغربل",
  "انفتح",
  "مصعوق",
  "إفراز",
  "تكاتف",
  "تنكيل",
  "مغمور",
  "انكسف",
  "تغريد",
  "مناصف",
  "تشويه",
  "ألفاظ",
  "تصميغ",
  "إنهاض",
  "تفريد",
  "مغصوب",
  "اعتجر",
  "تمثال",
  "قرآني",
  "تطاول",
  "انهدم",
  "انهزم",
  "مناطح",
  "متخيل",
  "إعسار",
  "مشفوط",
  "انعقد",
  "مطمور",
  "متصدع",
  "انبطح",
  "متفرع",
  "إلهام",
  "مرتاد",
  "مصطنع",
  "سماوي",
  "مقتبس",
  "مصنوع",
  "اجتاح",
  "معطوف",
  "ابتذل",
  "تعشيش",
  "تكامل",
  "خفايا",
  "تكثيف",
  "مشدود",
  "تغليظ",
  "إنفاذ",
  "تعجيب",
  "إقلال",
  "تصعير",
  "إطلاق",
  "تزخرف",
  "معاند",
  "إفلاس",
  "متربع",
  "متابع",
  "إصعاد",
  "تنشنش",
  "ملاحق",
  "ودائع",
  "مشاحن",
  "اغتبط",
  "اندثر",
  "تكتيل",
  "مبادر",
  "انهشم",
  "اقتدر",
  "مقترن",
  "تقسيم",
  "إهدار",
  "مسلطح",
  "إنقاص",
  "مفتول",
  "انصدع",
  "متكتل",
  "إنصاف",
  "مشكوك",
  "تنبيه",
  "تقابض",
  "ممانع",
  "تقييد",
  "مرابح",
  "ارتمس",
  "زعلان",
  "تفويض",
  "إلحاح",
  "منسوب",
  "تصفير",
  "غزالة",
  "توسيع",
  "انفرك",
  "تخلخل",
  "انفسح",
  "تكذيب",
  "إصفاد",
  "تنزيل",
  "ابتدع",
  "تكابر",
  "تخابث",
  "معكوس",
  "انخفض",
  "تقديم",
  "متلبد",
  "ارتسم",
  "تكبير",
  "منشود",
  "تكثير",
  "انخدش",
  "متكرر",
  "فضفاض",
  "معترش",
  "تفهيم",
  "ممراح",
  "تشاكل",
  "مقدور",
  "انغلق",
  "تجمهر",
  "انكشف",
  "ملبوس",
  "تغريق",
  "مواعد",
  "بسيطة",
  "مداهن",
  "تشامخ",
  "مقايض",
  "بشارة",
  "ملفوظ",
  "تشييد",
  "مسالم",
  "تهويد",
  "اصطبر",
  "تعدين",
  "تعشيق",
  "موزون",
  "تبارك",
  "تكفير",
  "إعداد",
  "ملتحم",
  "انثقب",
  "تكرير",
  "أحناش",
  "تغييب",
  "تواقح",
  "إعراض",
  "متآكل",
  "انحسر",
  "تعميل",
  "انجرف",
  "إنزال",
  "تفجير",
  "إعدام",
  "إفشال",
  "تأريخ",
  "إلهاب",
  "انفلج",
  "تخدير",
  "أموال",
  "تعذيب",
  "مجامل",
  "تعديد",
  "مغامر",
  "تصفيف",
  "تظهير",
  "مداول",
  "تهميم",
  "نضناض",
  "معترف",
  "واقعي",
  "تصالح",
  "ارتجع",
  "إيفاد",
  "تزامل",
  "ابتأس",
  "مدموغ",
  "تناكر",
  "تعظيم",
  "انهزل",
  "تفتيش",
  "معاقب",
  "تصليد",
  "انزعج",
  "مفسوخ",
  "تعزير",
  "إطباق",
  "تموين",
  "نتائج",
  "تمزيق",
  "أحمال",
  "تعفير",
  "أحماض",
  "تدارك",
  "انبتل",
  "تمييع",
  "انكمش",
  "تصفيح",
  "علاوة",
  "تطييح",
  "إضافة",
  "تعمير",
  "وراثي",
  "اكتمل",
  "ممتاز",
  "قاعدي",
  "انجبر",
  "إطراب",
  "انخدع",
  "أحفاد",
  "ترعرع",
  "إمساك",
  "تضليل",
  "احتضر",
  "خديجة",
  "مصابر",
  "إنجاح",
  "سماوة",
  "تمرير",
  "تلاطف",
  "مصحون",
  "انجمد",
  "تعطيس",
  "منمول",
  "تعبير",
  "إلمام",
  "تجوهر",
  "إعلام",
  "تنصيف",
  "معزوف",
  "أحباب",
  "متصنع",
  "تسامح",
  "متكلف",
  "توالد",
  "تنقيح",
  "مؤازر",
  "تفويت",
  "مصلصل",
  "انتفخ",
  "تقريع",
  "مشحون",
  "افتقر",
  "منزوع",
  "أبراج",
  "تضميخ",
  "انشرح",
  "متوزع",
  "تجامل",
  "مداخل",
  "اكترب",
  "مغلوط",
  "إيعاد",
  "منتفخ",
  "أكواب",
  "تشييع",
  "انهوس",
  "تطعيم",
  "كسلان",
  "مطراق",
  "تنظيف",
  "مسابق",
  "تصديع",
  "مذاكر",
  "احتذر",
  "مداخن",
  "التثم",
  "موافق",
  "إقلاق",
  "تصخير",
  "انطبق",
  "تقريف",
  "إنعاش",
  "مقرور",
  "تفاحش",
  "مقسوم",
  "اكتأب",
  "ملحون",
  "اختنق",
  "منزرع",
  "ابتهل",
  "إنقاذ",
  "مصلطح",
  "محاصر",
  "تلقين",
  "إعراب",
  "تنميق",
  "إضراب",
  "تمليك",
  "انحبس",
  "توقيف",
  "أمناء",
  "تضييع",
  "محالف",
  "مضارع",
  "إغفال",
  "تبشيع",
  "انتصر",
  "مهدوم",
  "ضحضاح",
  "مرفوع",
  "إيجاد",
  "متكثر",
  "صاعقة",
  "محاسب",
  "إطراد",
  "تماهل",
  "انفصم",
  "معالج",
  "تصليح",
  "مراهن",
  "ملاصق",
  "ملاكم",
  "إقلاع",
  "منتبه",
  "أشخاص",
  "تنجيم",
  "انتشر",
  "مخصخص",
  "مطبوخ",
  "انحفر",
  "أجيال",
  "منثور",
  "تضايق",
  "مهروش",
  "تنديد",
  "إلماع",
  "تفريط",
  "تسيير",
  "مؤاخذ",
  "تعويج",
  "ارتبط",
  "تعقيم",
  "انفضح",
  "تهويم",
  "ابتسر",
  "تعطيل",
  "دوران",
  "تكليب",
  "مشموم",
  "إتقاد",
  "مسنون",
  "ارتبك",
  "منحول",
  "إيقاظ",
  "أصالة",
  "تمسيد",
  "إعصار",
  "تمديد",
  "وسواس",
  "إظلام",
  "استبد",
  "خليفة",
  "احتزم",
  "تناصح",
  "التجم",
  "منتوج",
  "إهراق",
  "مسلوك",
  "انفقص",
  "توليد",
  "أهرام",
  "تسويغ",
  "انذهل",
  "تطفيح",
  "أجسام",
  "إفلات",
  "ليالي",
  "مفترض",
  "مماطل",
  "زيتون",
  "إطراح",
  "توكيد",
  "انظلم",
  "مناوش",
  "تقادم",
  "مقاوم",
  "تعبيد",
  "مناول",
  "انتخب",
  "إيهام",
  "استتر",
  "تكميل",
  "منافق",
  "تعويد",
  "مصطلح",
  "تقتير",
  "انصلح",
  "انقذف",
  "تمحيص",
  "احتشم",
  "معتمد",
  "مضروج",
  "تصاهر",
  "إعتام",
  "تعجرف",
  "اكتهل",
  "مشعور",
  "تنضيد",
  "مشاجر",
  "تفقير",
  "أحلام",
  "تيسير",
  "إعتاق",
  "متوتر",
  "إفساد",
  "منحوت",
  "أشجار",
  "تفريغ",
  "مصلوب",
  "تفاخر",
  "تكليل",
  "اضطرب",
  "متوقف",
  "اندعس",
  "توريث",
  "مجازف",
  "تعسيل",
  "مفروض",
  "إتكال",
  "مصدوع",
  "احتفز",
  "مخجول",
  "تعصير",
  "مواسم",
  "تنمير",
  "أوقات",
  "أختام",
  "انفغر",
  "إكمال",
  "تنصيب",
  "إظهار",
  "مخلوف",
  "ارتمض",
  "مدثور",
  "انتحل",
  "فريدة",
  "انهمك",
  "تغطرس",
  "أوهام",
  "تجرجر",
  "انغمس",
  "إفقار",
  "إصمام",
  "تغلغل",
  "مسامح",
  "تعريب",
  "مساهم",
  "تكشير",
  "مقلوب",
  "تصعيد",
  "وهجان",
  "أمينة",
  "تقاعس",
  "مهدور",
  "إيقاع",
  "مصهور",
  "إيقاد",
  "انتظم",
  "مبعوض",
  "هلاهل",
  "بنفسج",
  "تضاؤل",
  "منسوج",
  "مخملي",
  "أبواب",
  "تمركز",
  "أسباب",
  "تهديم",
  "أصناف",
  "تقليب",
  "اندمج",
  "تخضخض",
  "مطابق",
  "انعدم",
  "مبعوج",
  "ترابط",
  "موضوع",

]
